import type { SalaryAdvanceStatus } from "@/modules/hr/salary-advance/domain/contracts/types";

const STATUS_CONFIG: Record<
  SalaryAdvanceStatus,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
  }
> = {
  pending: { label: "ລໍຖ້າອະນຸມັດ", variant: "secondary" },
  approved: { label: "ອະນຸມັດແລ້ວ", variant: "default" },
  rejected: { label: "ປະຕິເສດ", variant: "destructive" },
  paid: { label: "ຈ່າຍແລ້ວ", variant: "default" },
  cancelled: { label: "ຍົກເລີກ", variant: "outline" },
  fully_repaid: { label: "ຫັກຄືນຄົບ", variant: "outline" },
};

const STATUS_COLOR: Record<SalaryAdvanceStatus, string> = {
  pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
  approved: "bg-blue-100 text-blue-800 border-blue-200",
  rejected: "bg-red-100 text-red-800 border-red-200",
  paid: "bg-purple-100 text-purple-800 border-purple-200",
  cancelled: "bg-gray-100 text-gray-600 border-gray-200",
  fully_repaid: "bg-green-100 text-green-800 border-green-200",
};

type Props = { status: SalaryAdvanceStatus };

export function AdvanceStatusBadge({ status }: Props) {
  const cfg = STATUS_CONFIG[status];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 font-medium text-xs ${STATUS_COLOR[status]}`}
    >
      {cfg.label}
    </span>
  );
}
